import React from 'react'

import { FormGroup, Label, Input, FormText, FormFeedback, InputGroup, InputGroupAddon } from 'reactstrap';


export const renderInput = (field) => {
    return (
        <FormGroup color={field.meta.touched && field.meta.error ? 'danger' : ''} >
	      <Label className={field.label ? '' : 'labelEmpty'} for={field.name}>{field.label}</Label>
	      <Input {...field.input} min="0" placeholder={field.placeholder} type={field.type} state={field.meta.touched && field.meta.error ? 'danger' : ''} maxLength={field.maxlength} />
	      {field.meta.touched && field.meta.error && <FormFeedback className="error-form">{field.meta.error}</FormFeedback>}
	    </FormGroup>
    )
};

export const renderInputUpperCase = (field) => {
    return (
        <FormGroup color={field.meta.touched && field.meta.error ? 'danger' : ''} >
            <Label className={field.label ? '' : 'labelEmpty'} for={field.name}>{field.label}</Label>
            <Input className="text-uppercase" {...field.input} min="0" placeholder={field.placeholder} type={field.type} state={field.meta.touched && field.meta.error ? 'danger' : ''} />
            {field.meta.touched && field.meta.error && <FormFeedback className="error-form">{field.meta.error}</FormFeedback>}
        </FormGroup>
    )
};

export const renderInputGroup = (field) => {
    return (
    	<FormGroup color={field.meta.touched && field.meta.error ? 'danger' : ''} >
    		<Label className={field.label ? '' : 'labelEmpty'} for={field.name}>{field.label}</Label>
	        <InputGroup  >
		      <Input {...field.input} min="0" placeholder={field.placeholder} type={field.type} state={field.meta.touched && field.meta.error ? 'danger' : ''} />
		      <InputGroupAddon>{field.group}</InputGroupAddon>
		    </InputGroup>
		    {field.meta.touched && field.meta.error && <FormFeedback className="error-form">{field.meta.error}</FormFeedback>}
	    </FormGroup>
    )
};

export const renderSelect = (field) => {
    return (
        <FormGroup color={field.meta.touched && field.meta.error ? 'danger' : ''} >
	        <Label className={field.label ? '' : 'labelEmpty'} for={field.name}>{field.label} {' '} </Label>
	        <Input type="select" {...field.input} state={field.meta.touched && field.meta.error ? 'danger' : ''} >
	           <option> {field.placeholder} </option>	
	          {field.options.map((option) => {
	                return <option value={option.id} key={option.id}>{option.name}</option>
	           })}
	        </Input>
	        {field.meta.touched && field.meta.error && <FormFeedback className="error-form">{field.meta.error}</FormFeedback>}
	    </FormGroup>
    )
};


export const renderSelectCheckbox = ({ label, required, name, options,  input, meta, customClass}) => {
    return (
        <FormGroup className={"input-radio " + (customClass ? customClass : '') } color={meta.touched && meta.error ? 'danger' : ''} >
	        <Label className={label ? '' : 'labelEmpty'} >{label} </Label>
	           <FormGroup check>
		          {options.map((option) => {
		                return (
			                <Label check  key={option.id}> 
			                	<input type="checkbox"
			                			className="form-check-input"
					                   name={`${name}[${option.id}]`}
					                   value={option.name}
					                   checked={input.value.indexOf(option.id) !== -1}
					                   onChange={event => {
					                     const newValue = [...input.value];
					                     if(event.target.checked) {
					                       newValue.push(option.id);
					                     } else {
					                       newValue.splice(newValue.indexOf(option.id), 1);
					                     }

					                     return input.onChange(newValue);
					                   }} />
					            {option.name}
			                </Label>
		                )
		           })}
	          </FormGroup>
	          {meta.touched && meta.error && <FormFeedback className="error-form">{meta.error}</FormFeedback>}
	    </FormGroup>
    )
};

export const renderRadio = (field) => {

	return (
          <Label check>
            <Input {...field.input} type="radio" /> {field.label}
          </Label>
    )
};




// WEBPACK FOOTER //
// ./src/utils/forms/renderers.js